export function isInternalEmail(email: string | undefined) {
  if (!email) {
    return false;
  }

  return email.endsWith("internal.io");
}
